import { reactive } from 'vue';
import { sendLogoutRequest } from "@/api/login";

export const userState = reactive({
    isLoggedIn: false,
    username: null,
    first_name: null,
    last_name: null,
    pending_actions: [],
});

export function setUserData(data) {
    if (!data) {
        userState.isLoggedIn = false;
        userState.username = null;
        userState.first_name = null;
        userState.last_name = null;
        userState.pending_actions = [];
        return;
    }

    userState.isLoggedIn = true;
    userState.username = data.username;
    userState.first_name = data.first_name;
    userState.last_name = data.last_name;
}

export function setPendingActions(actions) {
    userState.pending_actions = actions || [];
}

export function getFullUserName() {
    return `${userState.first_name} ${userState.last_name}`;
}

export async function logOut() {
    await sendLogoutRequest();
    window.location.href = '/';
}